/*!
=========================================================
* Painel Toca da Onça — Análise de Mercado (evolução do AvantPro)
=========================================================
* Ferramentas que FUNCIONAM agora (calculadora, gerador EAN) + análise de
* concorrentes (dados ao vivo quando o Mestre conectar o ML) + mapa das
* ferramentas por plataforma. Superior ao AvantPro pelos agentes de IA.
*/
import React from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Badge, Input, Button, Table } from "reactstrap";

const OURO = "#ffd700";
const brl = (v) =>
  "R$ " + Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function mediana(nums) {
  const s = [...nums].sort((a, b) => a - b);
  const m = Math.floor(s.length / 2);
  return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2;
}

const PLATAFORMAS_CALC = { "Mercado Livre": 13, "Shopee": 20, "Amazon": 15, "Magalu": 16, "Loja própria / balcão": 0 };

// Ferramentas por plataforma (tudo do AvantPro + o plus de IA)
const FERRAMENTAS = [
  {
    nome: "Mercado Livre", icon: "fas fa-shopping-cart", cor: "#ffe600", ic: "#2d3277",
    tools: [
      "Desempenho: vendas, faturamento, margem, CTR, posição na busca",
      "Concorrência: vendas reais 30 dias, preço médio, avaliações",
      "Palavras-chave: volume de busca + termos que vendem",
      "Detecta 50 produtos em alta agora",
      "Teste A/B de título, preço e foto",
      "Monitor de ranqueamento + aviso de queda",
      "Impulsionamento automático + exporta Excel",
    ],
    ia: "Repricer muda preço 24/7 e SEO gera o título campeão sozinho.",
  },
  {
    nome: "Shopee", icon: "fas fa-shopping-bag", cor: "#ee4d2d", ic: "#fff",
    tools: [
      "Posição na 1ª página por categoria",
      "Vendas reais dos concorrentes (30 dias)",
      "Calculadora nas regras da Shopee",
      "Sugestão de palavras-chave pro título",
      "Data de criação do anúncio do concorrente",
      "Alterações de preço/catálogo dos concorrentes",
      "Impulsionamento automático + fotos/vídeos",
    ],
    ia: "Scout prevê o próximo campeão cruzando TikTok/Instagram.",
  },
  {
    nome: "Amazon", icon: "fab fa-amazon", cor: "#ff9900", ic: "#111",
    tools: [
      "Visitas, vendas, conversão e margem",
      "Palavras-chave indexadas e de alta conversão",
      "Posição por palavra-chave",
      "Concorrentes: vendas estimadas, preço, histórico",
      "Teste A/B de conteúdo e preço",
      "Anúncios patrocinados + exporta planilha",
    ],
    ia: "Ads realoca o orçamento pros produtos de maior retorno.",
  },
];

// ===== FERRAMENTA REAL 1: Calculadora de lucratividade =====
function CalculadoraMkt() {
  const [plat, setPlat] = React.useState("Mercado Livre");
  const [custo, setCusto] = React.useState("30");
  const [frete, setFrete] = React.useState("0");
  const [imposto, setImposto] = React.useState("4");
  const [preco, setPreco] = React.useState("60");

  const n = (v) => Number(String(v).replace(",", ".")) || 0;
  const com = PLATAFORMAS_CALC[plat] || 0;
  const pv = n(preco);
  const custoTotal = n(custo) + n(frete);
  const comissaoRS = pv * (com / 100);
  const impostoRS = pv * (n(imposto) / 100);
  const lucro = pv - custoTotal - comissaoRS - impostoRS;
  const margem = pv > 0 ? (lucro / pv) * 100 : 0;
  const divisor = 1 - com / 100 - n(imposto) / 100;
  const precoMin = divisor > 0 ? custoTotal / divisor : 0;

  const campo = { width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #2c2c2c", background: "#161616", color: "#fff", fontSize: 14, outline: "none" };
  return (
    <Card>
      <CardHeader><CardTitle tag="h4"><i className="fas fa-calculator" style={{ color: OURO }} /> Calculadora de lucratividade <Badge color="success" pill>funciona agora</Badge></CardTitle></CardHeader>
      <CardBody>
        <Row>
          <Col md="4" style={{ marginBottom: 10 }}>
            <p className="text-muted" style={{ margin: "0 0 4px", fontSize: 12 }}>Onde vai vender</p>
            <select value={plat} onChange={(e) => setPlat(e.target.value)} style={campo}>
              {Object.keys(PLATAFORMAS_CALC).map((p) => <option key={p}>{p}</option>)}
            </select>
          </Col>
          <Col md="2" xs="6" style={{ marginBottom: 10 }}>
            <p className="text-muted" style={{ margin: "0 0 4px", fontSize: 12 }}>Custo da peça R$</p>
            <input value={custo} onChange={(e) => setCusto(e.target.value)} style={campo} inputMode="decimal" />
          </Col>
          <Col md="2" xs="6" style={{ marginBottom: 10 }}>
            <p className="text-muted" style={{ margin: "0 0 4px", fontSize: 12 }}>Frete R$</p>
            <input value={frete} onChange={(e) => setFrete(e.target.value)} style={campo} inputMode="decimal" />
          </Col>
          <Col md="2" xs="6" style={{ marginBottom: 10 }}>
            <p className="text-muted" style={{ margin: "0 0 4px", fontSize: 12 }}>Imposto %</p>
            <input value={imposto} onChange={(e) => setImposto(e.target.value)} style={campo} inputMode="decimal" />
          </Col>
          <Col md="2" xs="6" style={{ marginBottom: 10 }}>
            <p className="text-muted" style={{ margin: "0 0 4px", fontSize: 12 }}>Preço de venda R$</p>
            <input value={preco} onChange={(e) => setPreco(e.target.value)} style={campo} inputMode="decimal" />
          </Col>
        </Row>
        <Row style={{ marginTop: 6 }}>
          <Col md="3" xs="6"><p className="text-muted" style={{ margin: 0, fontSize: 12 }}>Comissão ({com}%)</p><p style={{ color: "#fd5d93", fontSize: 19, fontWeight: 700, margin: 0 }}>− {brl(comissaoRS)}</p></Col>
          <Col md="3" xs="6"><p className="text-muted" style={{ margin: 0, fontSize: 12 }}>Custo total + imposto</p><p style={{ color: "#fd5d93", fontSize: 19, fontWeight: 700, margin: 0 }}>− {brl(custoTotal + impostoRS)}</p></Col>
          <Col md="3" xs="6"><p className="text-muted" style={{ margin: 0, fontSize: 12 }}>Lucro líquido</p><p style={{ color: lucro >= 0 ? "#00f2c3" : "#fd5d93", fontSize: 22, fontWeight: 700, margin: 0 }}>{brl(lucro)} <small style={{ fontSize: 12 }}>({margem.toFixed(1)}%)</small></p></Col>
          <Col md="3" xs="6"><p className="text-muted" style={{ margin: 0, fontSize: 12 }}>Preço mínimo (empate)</p><p style={{ color: OURO, fontSize: 22, fontWeight: 700, margin: 0 }}>{brl(precoMin)}</p></Col>
        </Row>
      </CardBody>
    </Card>
  );
}

// ===== FERRAMENTA REAL 2: Gerador de EAN-13 (dígito verificador válido) =====
function GeradorEAN() {
  const [codigos, setCodigos] = React.useState([]);
  const gerar = () => {
    const novos = [];
    for (let k = 0; k < 10; k++) {
      let d = "789";
      for (let i = 0; i < 9; i++) d += Math.floor(Math.random() * 10);
      let soma = 0;
      for (let i = 0; i < 12; i++) soma += Number(d[i]) * (i % 2 === 0 ? 1 : 3);
      novos.push(d + ((10 - (soma % 10)) % 10));
    }
    setCodigos(novos);
  };
  const copiar = () => { try { navigator.clipboard.writeText(codigos.join("\n")); } catch (e) {} };
  return (
    <Card>
      <CardHeader><CardTitle tag="h4"><i className="fas fa-barcode" style={{ color: OURO }} /> Gerador de EAN-13 <Badge color="success" pill>funciona agora</Badge></CardTitle></CardHeader>
      <CardBody>
        <p className="text-muted" style={{ fontSize: 12.5 }}>
          Gera códigos EAN-13 com dígito verificador válido — pra etiqueta interna e cadastro no PDV.
          <b className="text-warning"> Honesto:</b> EAN oficial pra marketplace exige registro na GS1; este é pra uso interno.
        </p>
        <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
          <Button color="info" size="sm" onClick={gerar}>Gerar 10 códigos</Button>
          {codigos.length > 0 && <Button color="default" size="sm" onClick={copiar}>Copiar</Button>}
        </div>
        {codigos.length > 0 && (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
            {codigos.map((c, i) => (
              <code key={i} style={{ background: "#161616", color: "#00f2c3", padding: "6px 10px", borderRadius: 6, fontSize: 13 }}>{c}</code>
            ))}
          </div>
        )}
      </CardBody>
    </Card>
  );
}

function AnaliseMercado() {
  const [dados, setDados] = React.useState(null);
  const [termo, setTermo] = React.useState("vestido feminino");

  React.useEffect(() => {
    fetch("/analise_mercado.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => setDados(d))
      .catch(() => {});
  }, []);

  const produtos = (dados && dados.produtos) || [];
  const precos = produtos.map((p) => p.preco);
  const min = precos.length ? Math.min(...precos) : 0;
  const max = precos.length ? Math.max(...precos) : 0;
  const media = precos.length ? precos.reduce((a, b) => a + b, 0) / precos.length : 0;
  const med = precos.length ? mediana(precos) : 0;
  const totalVendidos = produtos.reduce((s, p) => s + (p.vendidos || 0), 0);
  const maisVendido = produtos.slice().sort((a, b) => b.vendidos - a.vendidos)[0];

  const custo = 30;
  const sugestao = Math.round((med * 0.97) * 100) / 100;
  const lucroSugestao = sugestao - custo - sugestao * 0.14 - sugestao * 0.05;

  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 style={{ color: OURO, fontWeight: 600 }}>
            <i className="fas fa-chart-line" /> Análise de Mercado & Ferramentas
          </h3>
          <p className="text-muted">Tudo do AvantPro + calculadora e gerador de EAN que já funcionam. Concorrentes ao vivo entram quando você conectar o ML.</p>
        </Col>
      </Row>

      {/* Ferramentas que funcionam AGORA */}
      <Row>
        <Col lg="7" md="12"><CalculadoraMkt /></Col>
        <Col lg="5" md="12"><GeradorEAN /></Col>
      </Row>

      {/* Análise de concorrentes */}
      <Row>
        <Col xs="12">
          <h4 className="text-white" style={{ fontWeight: 300, borderLeft: "3px solid " + OURO, paddingLeft: 12 }}>
            Espião de concorrentes — Mercado Livre
          </h4>
          {dados && dados.modo === "exemplo" && (
            <div style={{ background: "rgba(255,176,32,.12)", border: "1px solid rgba(255,176,32,.4)", borderRadius: 10, padding: "10px 14px", marginBottom: 8 }}>
              <span className="text-warning">
                <i className="tim-icons icon-alert-circle-exc" /> Modo exemplo — conecte seu Mercado Livre pra dados reais ao vivo (card abaixo).
              </span>
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col md="8">
          <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
            <Input value={termo} onChange={(e) => setTermo(e.target.value)} placeholder="ex: vestido feminino, conjunto fitness" />
            <Button color="info">Analisar</Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg="3" md="6"><Card className="card-stats"><CardBody><p className="card-category text-muted">Menor preço</p><CardTitle tag="h3" className="text-success">{brl(min)}</CardTitle></CardBody></Card></Col>
        <Col lg="3" md="6"><Card className="card-stats"><CardBody><p className="card-category text-muted">Preço médio</p><CardTitle tag="h3" style={{ color: OURO }}>{brl(media)}</CardTitle></CardBody></Card></Col>
        <Col lg="3" md="6"><Card className="card-stats"><CardBody><p className="card-category text-muted">Maior preço</p><CardTitle tag="h3" className="text-warning">{brl(max)}</CardTitle></CardBody></Card></Col>
        <Col lg="3" md="6"><Card className="card-stats"><CardBody><p className="card-category text-muted">Total vendido (amostra)</p><CardTitle tag="h3" className="text-white">{totalVendidos.toLocaleString("pt-BR")}</CardTitle></CardBody></Card></Col>
      </Row>
      <Row>
        <Col lg="7" md="12">
          <Card>
            <CardHeader><CardTitle tag="h4">Concorrentes ({produtos.length})</CardTitle></CardHeader>
            <CardBody>
              <Table className="tablesorter" responsive>
                <thead className="text-primary">
                  <tr><th>Produto</th><th className="text-center">Preço</th><th className="text-center">Vendidos</th><th className="text-center">UF</th></tr>
                </thead>
                <tbody>
                  {produtos.map((p, i) => (
                    <tr key={i}>
                      <td>{p.titulo}</td>
                      <td className="text-center">{brl(p.preco)}</td>
                      <td className="text-center">{(p.vendidos || 0).toLocaleString("pt-BR")}</td>
                      <td className="text-center"><Badge color="primary" pill>{p.uf}</Badge></td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
        <Col lg="5" md="12">
          <Card>
            <CardHeader><CardTitle tag="h4"><i className="tim-icons icon-atom" style={{ color: OURO }} /> Sugestão da IA</CardTitle></CardHeader>
            <CardBody>
              <p className="text-muted">Com base na mediana ({brl(med)}) e no seu custo de {brl(custo)}:</p>
              <div style={{ background: "rgba(29,205,159,.08)", borderRadius: 10, padding: 16, marginBottom: 12 }}>
                <p className="text-muted" style={{ margin: 0 }}>Preço sugerido pra girar rápido</p>
                <h2 className="text-success" style={{ margin: "4px 0" }}>{brl(sugestao)}</h2>
                <p className="text-muted" style={{ margin: 0 }}>Lucro estimado: <span className="text-success">{brl(lucroSugestao)}</span> (já tirando 14% + 5%)</p>
              </div>
              {maisVendido && (
                <p className="text-muted">
                  <i className="tim-icons icon-trophy text-warning" /> Campeão: <b className="text-white">{maisVendido.titulo}</b> a {brl(maisVendido.preco)} ({maisVendido.vendidos.toLocaleString("pt-BR")} vendidos).
                </p>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Ferramentas por plataforma */}
      <Row>
        <Col xs="12">
          <h4 className="text-white" style={{ fontWeight: 300, borderLeft: "3px solid " + OURO, paddingLeft: 12, marginTop: 10 }}>
            Ferramentas por plataforma <span className="text-muted" style={{ fontSize: 13 }}>— tudo do AvantPro + o nosso plus de IA</span>
          </h4>
        </Col>
      </Row>
      <Row>
        {FERRAMENTAS.map((p, i) => (
          <Col lg="4" md="6" key={i}>
            <Card style={{ minHeight: 320 }}>
              <CardBody>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: p.cor, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <i className={p.icon} style={{ fontSize: 20, color: p.ic }} />
                  </div>
                  <CardTitle tag="h4" className="text-white" style={{ margin: 0 }}>{p.nome}</CardTitle>
                </div>
                {p.tools.map((t, j) => (
                  <div key={j} style={{ display: "flex", gap: 8, alignItems: "flex-start", marginBottom: 6 }}>
                    <i className="tim-icons icon-check-2" style={{ color: "#00f2c3", fontSize: 13, marginTop: 3, flexShrink: 0 }} />
                    <span className="text-muted" style={{ fontSize: 12.5, lineHeight: 1.4 }}>{t}</span>
                  </div>
                ))}
                <div style={{ marginTop: 10, background: "rgba(255,215,0,.08)", borderRadius: 8, padding: "8px 10px" }}>
                  <span style={{ color: OURO, fontSize: 12 }}><i className="tim-icons icon-atom" /> IA: {p.ia}</span>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      <Row>
        <Col xs="12">
          <Card style={{ border: "1px solid rgba(255,215,0,.3)" }}>
            <CardBody>
              <CardTitle tag="h4" className="text-white"><i className="tim-icons icon-key-25" style={{ color: OURO }} /> Ligar os dados ao vivo (3 passos seus)</CardTitle>
              <ol className="text-muted" style={{ lineHeight: 1.9 }}>
                <li>Entre em <b style={{ color: OURO }}>developers.mercadolivre.com.br</b> → "Criar aplicação" (grátis).</li>
                <li>Copie o <b>App ID</b> e a <b>Secret Key</b> num arquivo de texto na Área de Trabalho.</li>
                <li>Me avise — eu leio pelo script (sem ver no chat), completo o login e os dados/agentes ligam.</li>
              </ol>
              <Button color="info" tag="a" target="_blank" rel="noreferrer" href="https://developers.mercadolivre.com.br/devcenter">
                Abrir o DevCenter do Mercado Livre <i className="tim-icons icon-minimal-right" style={{ fontSize: 10 }} />
              </Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default AnaliseMercado;
